import { toast } from '@approvalmax/ui/src/components';
import { selectors } from 'modules/common';
import { useCallback } from 'react';
import { FieldErrors, useForm } from 'react-hook-form';
import { useDeleteCompany } from 'shared/data/webApp/v1';
import { getDefaultPath } from 'urlBuilder';

import { messages } from './PopupDeleteOrganisation.messages';
import { PopupDeleteOrganisationFormData } from './PopupDeleteOrganisation.types';

export const usePopupDeleteOrganisationData = (company: selectors.types.ExpandedCompany) => {
    const { mutate, isLoading } = useDeleteCompany();

    const form = useForm<PopupDeleteOrganisationFormData>({
        defaultValues: {
            confirmation: '',
            agreed: false,
        },
        mode: 'onChange',
        resolver: async (values) => {
            const errors: FieldErrors<PopupDeleteOrganisationFormData> = {};

            if (values.agreed !== company.flags.isPaid) {
                errors.agreed = {
                    type: 'required',
                };
            }

            if (values.confirmation.toLowerCase() !== messages.delete.toLowerCase()) {
                errors.confirmation = {
                    type: 'pattern',
                };
            }

            return {
                values: Object.keys(errors).length > 0 ? {} : values,
                errors,
            };
        },
    });

    const onDelete = useCallback(() => {
        mutate(
            { body: { companyId: company.id } },
            {
                onSuccess: () => {
                    toast.success(messages.organisationHasBeenRemoved);
                    window.location.href = getDefaultPath();
                },
            }
        );
    }, [company.id, mutate]);

    return {
        form,
        isLoading,
        canSubmit: !isLoading && form.formState.isDirty && Object.keys(form.formState.errors).length === 0,
        onFormSubmit: form.handleSubmit(onDelete),
    };
};
